"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectListConverter_1 = require("../../core/conversions/DataObjectListConverter");
/**
 * @author OPt
 */


var ForecastCoordinatorTreeDataDTOConverter =
/*#__PURE__*/
function (_DataObjectListConver) {
  _inherits(ForecastCoordinatorTreeDataDTOConverter, _DataObjectListConver);

  function ForecastCoordinatorTreeDataDTOConverter() {
    _classCallCheck(this, ForecastCoordinatorTreeDataDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastCoordinatorTreeDataDTOConverter).apply(this, arguments));
  }

  return ForecastCoordinatorTreeDataDTOConverter;
}(DataObjectListConverter_1.DataObjectListConverter);

exports.ForecastCoordinatorTreeDataDTOConverter = ForecastCoordinatorTreeDataDTOConverter;